

import React, { Component } from "react";
import { Button, Form, Row } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "./Abha.css";

import ReCAPTCHA from 'react-google-recaptcha';

export default class AbhaNumberverifyotp extends Component {
  constructor(props) {
    super(props);
       this.recaptchaRef = React.createRef();
    
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      message: sessionStorage.getItem("message"),
      aadharNumber: sessionStorage.getItem("aadhaarNumber"),
      abhaotp: ["", "", "", "", "", ""],
      AbhaProfile: {},
      abhanumber: ["", "", "", ""],
      mobile: "",
      showOtp: false,
      showAbha: false,
      cabhaaddress: "",
      custshowAddess: false,
      isAbhaVerifiedReady: false,
      authMethods: "",
      resendTimer: 60, // 1 minutes
      resendEnabled: false,
      resendIntervalId: null,
      captchaToken: null,

      // ["AADHAAR_OTP", "MOBILE_OTP"]
    };
  }
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpANCount:  parseInt(sessionStorage.getItem("resendOtpANCount")) || 0,
      resendTimer: 60,
    });
    const intervalId = setInterval(() => {
      this.setState((prevState) => {  
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };
  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount = parseInt(sessionStorage.getItem("resendOtpANCount")) || 0;
    if (resendCount >= 2) {
      this.showToast("Maximum resend attempts reached.", "error");
      return;
    }
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhaverify/resendAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        const isValid =
        data.status === "success" &&
        data.requestId && data.requestId !== 0 &&
        (!data.details || !data.details[0]?.message?.includes("Invalid"));

      if (isValid) {
        resendCount++;
        sessionStorage.setItem("resendOtpANCount", resendCount);
        this.showToast("OTP resent successfully!", "success");
        clearInterval(this.state.resendIntervalId);
        this.startResendCountdown();
      } else {
        const errorMsg = data?.detail?.[0]?.message||data.message || "OTP resend failed. Please try again.";
         this.showToast(errorMsg);
      }
    })
   
  };
  componentDidMount() {
    // this.ResponseHandler();

    const abhanumberRaw = sessionStorage.getItem("abhanumber");
    if (abhanumberRaw) {
      const abhaPlain = abhanumberRaw.replace(/-/g, ""); // Remove dashes
      if (abhaPlain.length === 14) {
        const abhaSplit = [
          abhaPlain.slice(0, 2),
          abhaPlain.slice(2, 6),
          abhaPlain.slice(6, 10),
          abhaPlain.slice(10, 14),
        ];
        this.setState({ abhanumber: abhaSplit });
      }
    }
    if (!sessionStorage.getItem("resendOtpANCount")) {
      sessionStorage.setItem("resendOtpANCount", "0");
    }
    this.startResendCountdown();
  }
  // ResponseHandler = () => {
  //   const { requestId } = this.state;
  //   const formData = new FormData();
  //   formData.append("requestId", requestId);
  
  //   fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.text()) // Get raw text
  //     .then((text) => {
  //       if (!text) {
  //         this.showToast("Empty response from server.", "error");
  //         return;
  //       }
  
  //       let data;
  //       try {
  //         data = JSON.parse(text);
  //       } catch (err) {
  //         this.showToast("Invalid JSON format received.", "error");
  //         return;
  //       }
  
  //       if (data.status === "success" && data.detail) {
  //         const rawProfile = data.detail.abhaprofile;
  
  //         if (rawProfile) {
  //           try {
  //             const abhaDetails = JSON.parse(rawProfile);
  //             const abhaProfile = abhaDetails?.ABHAProfile;
  
  //             if (abhaProfile) {
  //               this.setState({
  //                 AbhaProfile: abhaProfile,
  //                 abhanumber: this.state.abhanumber,
  //               });
  //             } 
  //           } catch {
  //             this.showToast("ABHA profile could not be parsed.", "error");
  //           }
  //         } 
  //       } else {
  //         this.showToast(data.message || "Profile fetch failed.", "error");
  //       }
  //     })
  //     .catch(() => {
  //       this.showToast("Something went wrong. Please try again.", "error");
  //     });
  // };
    showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };

  handleabhaIdChange = (index, value) => {
    const updated = [...this.state.abhanumber];
    const limit = index === 0 ? 2 : 4;
    updated[index] = value.replace(/\D/g, "").slice(0, limit);
    this.setState({ abhanumber: updated });
  };

  handleabhaotpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      // allow only single digit or empty
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.abhaotp];
          newOtp[index] = val;
          return { abhaotp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput${index + 1}`].focus();
          }
        }
      );
    }
  };
  handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.abhaotp[index] && index > 0) {
      this[`otpInput${index - 1}`].focus();
    }
  };

  handleSubmitNext = (e) => {
    e.preventDefault();
    const { abhanumber, authMethods } = this.state;
    const fullabhanumber = `${abhanumber[0]}-${abhanumber[1]}-${abhanumber[2]}-${abhanumber[3]}`;
    const abhaPlain = abhanumber.join("");
    const abhaRegex = /^\d{14}$/;
    if (!abhaRegex.test(abhaPlain)) {
      this.showToast("ABHA number must be exactly 14 digits.", "error");
      return;
    }
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));
    var formData = new FormData();

    formData.append("abhanumber", fullabhanumber);
    formData.append("authMethods", authMethods);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhaverify/submitAbhaNumber", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("resendOtpANCount", "");
          this.setState({
            responseMessage: data.details.message,
            message: data.message,
            showMessage: true,
          });
        } else {
          this.setState({
            responseMessage: "Something Went Wrong",
            showMessage: true,
          });
        }
      });
  };
  handleSubmitOTPNext = (e) => {
    e.preventDefault();
    const { abhanumber, aadharNumber ,  captchaToken} = this.state;
    const abhaotp = this.state.abhaotp.join("");
    if (!captchaToken) {
       this.showToast('Please verify that you are not a robot!',"error");
      return;
    }
    sessionStorage.setItem("abhaotp", this.state.abhaotp);
    var formData = new FormData();
    formData.append("abhaotp", abhaotp);
    formData.append("captchaToken", captchaToken);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhaverify/submitAbhaOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          sessionStorage.setItem("aadharNumber", aadharNumber);
          sessionStorage.setItem("resendOtpANCount", "");
          sessionStorage.setItem("requestId", data.requestId|| this.state.requestId); 
          sessionStorage.setItem("abhanumber", abhanumber.join("-"));
          // window.location.href = "/abhanumberprofile";
this.handlenextClick()
          this.setState({
            resendOtpANCount: "",
          });
          if (this.recaptchaRef && this.recaptchaRef.current) {
            this.recaptchaRef.current.reset(); // ✅ Reset after submission
          }
        }
        
  
        this.setState({
          aadhaarNumber: "",
          isSubmitting: false,
        });
  
       
      })
      // .catch((error) => {
      //   console.error("API error:", error);
      //    this.showToast("An unexpected error occurred. Please try again later.");
      //   this.setState({ isSubmitting: false });
      // });
  };
  handlenextClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/getAbhaProfile", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        sessionStorage.setItem("abhaAddress", this.state.phrAddress);
        sessionStorage.setItem("aadharNumber", aadharNumber);
        sessionStorage.setItem("abhanumber", abhanumber);
        this.showToast(data.message);

        if (data.status === "success") {
          window.location.href = "/abhanumberprofile";
        }
      });
  }; 

  toggleOtpVisibility = () => {
    this.setState((prevState) => ({ showOtp: !prevState.showOtp }));
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleShareClickClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleQRCodeClickClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhaverify/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };
handleDownloadPng = async (url) => {
 
  try {
    
    const requestId = sessionStorage.getItem("requestId") || "file";

    // Fetch file as blob
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();

    // Create temporary URL
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Preserve file extension from blob type
    const ext = blob.type.split("/")[1] || "png"; // fallback
    link.download = `${requestId}.${ext}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Release memory
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};
  HandleNextSubmit = () => {
    window.location.href = "/existingabhaverification";
  };
  HandleNewClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber.join("-"));
    // sessionStorage.setItem("abhaAddress", abhaAddress);

    window.location.href = "/abhaaddresscreation";
  };

  handleImageClick = (option) => {
    this.setState({ authMethods: option });
  };
  handleSubmitBack = (e) => {
    e.preventDefault();
    
    sessionStorage.setItem("resendOtpANCount", "");    
    window.location.href = "/download";
  }

  render() {
    const {
      message,
      abhaotp,
      resendEnabled,
      resendTimer,
    } = this.state;
    return (
      <div> 
         {/* <div className="row mb-2" id="flowStyle">
                <div className="col-md-3 flowTab Inactive">
                  <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
                    <p className="nav-label mt-2">Consent Collection</p>
                  </div>
                </div>
      
                <div className="col-md-3 flowTab Inactive">
                  <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
                    <p className="nav-label mt-2">Mobile Authentication</p>
                  </div>
                </div>
                <div className="col-md-3 flowTab active-page">
                  <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
                    <p className="nav-label mt-2">ABHA verification</p>
                  </div>
                </div>
                <div className="col-md-3 flowTab Inactive">
                  <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
                    <p className="nav-label mt-2">Profile Collection</p>
                  </div>
                </div>
          </div> */}
        <div className="row justify-content-md-center text-center abhaverification">
       
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
           

              <Form.Group>
                <Form.Label>
                  <b>Enter</b>
                  <i style={{ color: "blue" }}>{message}</i>
                </Form.Label>
                {this.state.showMessage && (
                  <i style={{ color: "blue" }}>{this.state.message}</i>
                )}
                <div className="d-flex gap-2 text-center">
                  {abhaotp.map((digit, index) => (
                    <Form.Control
                      key={index}
                      type={this.state.showOtp ? "text" : "password"}
                      maxLength="1"
                      value={digit}
                      onChange={(e) => this.handleabhaotpChange(e, index)}
                      onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                      ref={(input) => (this[`otpInput${index}`] = input)}
                      className="form-control"
                    />
                  ))}

                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      this.state.showOtp ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={this.toggleOtpVisibility}
                  />
                </div>
                <Row>
                  <div className="col">
                    {parseInt(sessionStorage.getItem("resendOtpANCount")) >=
                    2 ? (
                      <div style={{ color: "red", fontWeight: "bold" }}>
                      You’ve reached the maximum resend attempts.
                    </div>
                    ) : (
                      <>
                      <Button
                        className="rounded-0 m-1"
                        variant="warning"
                        onClick={this.ResendOTP}
                        disabled={!resendEnabled}
                      >
                        Resend OTP{" "}
                        {!resendEnabled && 
                        `in ${this.formatTime(resendTimer)}`}
                      </Button>
                      <div style={{ fontSize: "12px", color: "gray" }}>
                       Resend OTP Send Only 2 Times in a Session You have used &nbsp;
                        {sessionStorage.getItem("resendOtpANCount")||0} out of 2.
                      </div>
                      </>
                    )}
                  </div>
                  <div className="d-flex">   
                    <ReCAPTCHA 
          className="mt-4"
          ref={this.recaptchaRef} 
          sitekey= {configData.captchaKey}
          onChange={this.handleCaptchaChange}
        /> 
        <Button variant="secondary"  className="bi bi-arrow-clockwise re-chaptue" 
                onClick={() => this.recaptchaRef.current.reset()}/>
                </div>
                </Row>
              </Form.Group>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
           <div className="col text-start">
                 <Button className="rounded-0 m-1 " variant="warning"  onClick={this.handleSubmitBack}
                    >
                      Back
                    </Button>
                  </div>
          <div className="col text-end">
      
            <Button
              className="rounded-0 m-1"
              disabled={abhaotp.some(((d) => d === "") || abhaotp !== 6)}
              onClick={this.handleSubmitOTPNext}
            >
              {this.state.isSubmitting
                ? "Submitting..."
                : "Verify\u00A0ABHAOTP"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
